// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 56) return "static/css/56.f7248e91244acdae709e.lib.css";
	if (chunkId === 963) return "static/css/963.2ac2961ed2b68da59327.css";
	if (chunkId === 949) return "static/css/949.26c4680c9abbbb83c280.css";
	if (chunkId === 697) return "static/css/697.11f14d838f7fd3c876b9.css";
	// return url for filenames based on template
	return undefined;
};